/**
 * * Запорс на проверку является ли пользователь приглашенным на оценку задачи
 */
export class CheckEstimateRequestModel {
  /**
   * * Айди задачи
   */
  TaskId!: number;
  constructor(obj?: Partial<CheckEstimateRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
